import { NavItem } from "@/types/interface";
import {
  Box,
  Boxes,
  CalendarSync,
  Database,
  FastForward,
  File,
  HandHelping,
  LayoutDashboard,
  MapPinned,
  MessageCircleWarning,
  Monitor,
  PanelsTopLeft,
  UserRound,
} from "lucide-react";
export const BASE_URL = process.env.NEXT_PUBLIC_API_URL;
export const REGION_URL = process.env.NEXT_PUBLIC_API_REGION;

type navDateType = {
  navItems: NavItem[];
};

export const getNavData = (): navDateType => {
  return {
    navItems: [
      {
        title: "Dashboard",
        icon: LayoutDashboard,
        url: "/dashboard",
      },
      {
        title: "GIS",
        icon: MapPinned,
        url: "/gis",
      },
      {
        title: "Pengajuan",
        icon: HandHelping,
        url: "/submission",
        items: [
          {
            title: "Pupuk",
            url: "/submission/fertilizer",
          },
          {
            title: "Tanaman",
            url: "/submission/plant",
          },
          {
            title: "Alsintan",
            url: "/submission/alsintan",
          },

          {
            title: "Pengajuan Ditolak",
            url: "/submission/submission-rejected",
          },
        ],
      },
      {
        title: "Perpanjangan",
        icon: FastForward,
        url: "/extend-alsintan",
        items: [
          {
            title: "Semua",
            url: "/extend-alsintan/list",
          },
          {
            title: "Ditolak",
            url: "/extend-alsintan/extend-rejected",
          },
        ],
      },
      {
        title: "Pengembalian",
        icon: CalendarSync,
        url: "/return",
        items: [
          {
            title: "Semua",
            url: "/return/list",
          },
          {
            title: "Ditolak",
            url: "/return/rejected",
          },
        ],
      },

      {
        title: "Monitoring",
        icon: Monitor,
        url: "/monitoring",
        items: [
          {
            title: "Pupuk",
            url: "/monitoring/fertilizer",
          },
          {
            title: "Tanaman",
            url: "/monitoring/plant",
          },
          {
            title: "Alsintan",
            url: "/monitoring/alsintan",
          },
        ],
      },
      {
        title: "Manajemen Pengguna",
        icon: UserRound,
        url: "/user-management",
        items: [
          {
            title: "Verifikasi Akun",
            url: "/user-management/verification",
          },
          {
            title: "Poktan",
            url: "/user-management/poktan",
          },
          {
            title: "Pengguna",
            url: "/user-management/user",
          },
        ],
      },
      {
        title: "Kelola Aset",
        icon: Boxes,
        url: "/assets",
      },
      {
        title: "Kelola Stok",
        icon: Box,
        url: "/stock-management",
        items: [
          {
            title: "Pupuk",
            url: "/stock-management/fertilizer",
          },
          {
            title: "Tanaman",
            url: "/stock-management/plant",
          },
          // {
          //   title: "Alsintan",
          //   url: "/stock-management/alsintan",
          // },
        ],
      },
      {
        title: "Pengaduan",
        icon: MessageCircleWarning,
        url: "/complaint",
      },
      {
        title: "Manajemen Website",
        icon: PanelsTopLeft,
        url: "/website-management",
        items: [
          {
            title: "Aplikasi Pendukung",
            url: "/website-management/support-apps",
          },
          {
            title: "Pengumuman",
            url: "/website-management/announcement",
          },
          {
            title: "Dokumentasi",
            url: "/website-management/documentation",
          },
          {
            title: "Pertanyaan SKM",
            url: "/website-management/skm-question",
          },
          {
            title: "Data SKM",
            url: "/website-management/data-skm",
          },
          {
            title: "Blog",
            url: "/website-management/blog",
          },
          {
            title: "FAQ",
            url: "/website-management/faq",
          },
        ],
      },
      {
        title: "Laporan",
        icon: File,
        url: "/report",
        items: [
          {
            title: "Laporan Distribusi PPPB",
            url: "/report/distribution-pppb",
          },
          {
            title: "Pupuk",
            url: "/report/fertilizer",
          },
          {
            title: "Tanaman",
            url: "/report/plant",
          },
          {
            title: "Alsintan (Pinjam Pakai)",
            url: "/report/alsintan/borrow",
          },
          {
            title: "Alsintan (Hibah)",
            url: "/report/alsintan/hibah",
          },
          {
            title: "Pengembalian Alsintan",
            url: "/report/alsintan/return",
          },
          {
            title: "Asset Alsintan",
            url: "/report/alsintan/asset",
          },
          {
            title: "Stok Pupuk",
            url: "/report/stock/fertilizer",
          },
          {
            title: "Stok Tanaman",
            url: "/report/stock/plant",
          },
          {
            title: "Luas Lahan",
            url: "/report/land-area",
          },
        ],
      },
      {
        title: "Data Master",
        icon: Database,
        url: "/master",
        items: [
          {
            title: "Instansi",
            url: "/master/instance",
          },
          {
            title: "Pupuk",
            url: "/master/fertilizer",
          },
          {
            title: "Tanaman",
            url: "/master/plant",
          },
          {
            title: "Kategori Alsintan",
            url: "/master/alsintan-category",
          },
          {
            title: "Alsintan",
            url: "/master/alsintan",
          },
          {
            title: "Kepemilikan Lahan",
            url: "/master/land-status",
          },
          {
            title: "Metode Pengantaran",
            url: "/master/delivery",
          },
          {
            title: "Syarat dan Ketentuan",
            url: "/master/tnc",
          },
          {
            title: "Penggunaan Pupuk",
            url: "/master/fertilizer-application",
          },
          {
            title: "Tanda Tangan",
            url: "/master/signature",
          },
        ],
      },
    ],
  };
};

export type NavItemLan = {
  key: string;
  label: string;
  url?: string;
  children?: NavItemLan[];
};
export const navbarItems: NavItemLan[] = [
  { key: "home", label: "Beranda", url: "/" },
  { key: "pengumuman", label: "Pengumuman", url: "/announcement" },
  {
    key: "Informasi Publik",
    label: "Informasi Publik",
    children: [
      {
        key: "Berita",
        label: "Berita",
        url: "/information/news",
      },
      {
        key: "dokumentasi",
        label: "Dokumentasi",
        url: "/information/documentation",
      },
      {
        key: "manual",
        label: "Buku Panduan",
        url: "/information/manual-book",
      },
    ],
  },
  { key: "aplikasi", label: "Aplikasi Pendukung", url: "/support-apps" },
  { key: "skm", label: "Survey & Pengaduan", url: "/skm" },
];

export const genderOptions = [
  {
    label: "Laki - Laki",
    value: "MALE",
  },
  {
    label: "Perempuan",
    value: "FEMALE",
  },
];

export const genderOptionValue = {
  MALE: "Laki - Laki",
  FEMALE: "Perempuan",
};

export const skmValue = [
  "Sangat Setuju",
  "Setuju",
  "Netral",
  "Tidak Setuju",
  "Sangat Tidak Setuju",
];

export const appTypeOptionValue = {
  SIPUTANI: "SIMPUPUK",
  SITANAMAN: "SIMTANAMAN",
  ALSINTAN: "ALSINTAN",
} as const;

export const positionSignature = {
  KABID: "Kabid  Prasarana dan Sarana",
  BENDAHARA: "Bendahara Barang",
  KEPALA_DINAS: "Kepala Dinas Pertanian",
};
